<div id="background-check" class="flex">
  <div name="right-banner" class="hidden md:block flex justify-center md:w-1/2 px-20">
    <div class="mb-8 flex flex-col justify-center">
      <div class="pt-12 pb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty.thumb}}>
      </div>
      <div class="flex justify-between items-end">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty.baths}}</span> ba | <span
              class="font-bold">{{modelProperty.sqft}}</span> sqft</p>
        </div>
      </div>
      <div class="pb-4">
        <div>{{modelProperty.title}}</div>
      </div>
      <div>
        <div *ngIf="splashHTML != null" class="bg-white h-32" [innerHTML]="splashHTML"></div>
      </div>
    </div>
  </div>
  <div name="main" class="p-8 flex flex-col sm:w-auto md:w-1/2 bg-white">
    <div class="flex flex-col sm:w-auto md:hidden p-8">
      <div class="mb-2">
        <img class="img-responsive rounded-lg" src={{modelProperty.thumb}}>
      </div>
      <div class="flex justify-between items-end ">
        <div>
          <p><span class="text-lg font-bold">${{modelProperty.rent}}</span> /mo</p>
        </div>
        <div class="justify-items-end">
          <p class="text-right"><span class="font-bold">{{modelProperty.beds}}</span> bd | <span
              class="font-boldr">{{modelProperty.baths}}</span> ba | <span
              class="font-bold">{{modelProperty.sqft}}</span> sqft</p>
        </div>
      </div>
      <div>
        <div>{{modelProperty.title}}</div>
      </div>
    </div>
    <div class="md:px-16">
      <div>
        <div class="pb-4">
          <h2 class="text-4xl my-2 use-rhetorik-sans">Rental Application</h2>
        </div>
        <div class="box-border-inactive">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">1/{{totalApplicationSteps}}</h2>
          </div>
          <div class="col-span-6">
            <h2 class="text-lg font-bold my-6">Contact Information</h2>
          </div>
          <div class="col-span-3 text-right">
            <button mat-flat-button color="accent" class="h-10 px-6 mt-6 text-right" routerLink="/application/basic"
              routerLinkActive="active">UPDATE</button>
          </div>
        </div>
        <div class="box-border-inactive">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">2/{{totalApplicationSteps}}</h2>
          </div>
          <div class="col-span-6">
            <h2 class="text-lg font-bold my-6">Personal Information</h2>
            <p>Driver's license, social security, marital status, children and pets</p>
          </div>
          <div class="col-span-3 text-right">
            <button mat-flat-button color="accent" class="h-10 px-6 mt-6 text-right" routerLink="/application/personal"
              routerLinkActive="active">UPDATE</button>
          </div>
        </div>
        <div class="box-border-inactive">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">3/{{totalApplicationSteps}}</h2>
          </div>
          <div class="col-span-6">
            <h2 class="text-lg font-bold my-6">Residency History</h2>
            <p>Two years of residency history information</p>
          </div>
          <div class="col-span-3 text-right">
            <button mat-flat-button color="accent" class="h-10 px-6 mt-6 text-right" routerLink="/application/residency"
              routerLinkActive="active">UPDATE</button>
          </div>
        </div>
        <div class="box-border-inactive">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">4/{{totalApplicationSteps}}</h2>
          </div>
          <div class="col-span-6">
            <h2 class="text-lg font-bold my-6">Employment Information</h2>
            <p>Two years of employment information</p>
          </div>
          <div class="col-span-3 text-right">
            <button mat-flat-button color="accent" class="h-10 px-6 mt-6 text-right"
              routerLink="/application/employment" routerLinkActive="active">UPDATE</button>
          </div>
        </div>
        <div class="box-border-inactive">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">5/{{totalApplicationSteps}}</h2>
          </div>
          <div class="col-span-6">
            <h2 class="text-lg font-bold my-6">Verify Income</h2>
          </div>
          <div class="col-span-3 text-right">
            <button mat-flat-button color="accent" class="h-10 px-6 mt-6 text-right" routerLink="/application/documents"
              routerLinkActive="active">UPDATE</button>
          </div>
        </div>
        <div class="box-border-inactive">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">6/{{totalApplicationSteps}}</h2>
          </div>
          <div class="col-span-6">
            <h2 class="text-lg font-bold my-6">Background Check</h2>
            <p>You have agreed to the Terms and Conditions</p>
          </div>
          <div class="col-span-3 text-right">
            <button mat-flat-button color="accent" class="h-10 px-6 mt-6 text-right"
              routerLink="/application/background-check" routerLinkActive="active">UPDATE</button>
          </div>
        </div>
        <div class="box-border-active">
          <div class="col-span-1">
            <h2 class="text-lg text-gray-600 font-bold my-6 pr-6">7/{{totalApplicationSteps}}</h2>
          </div>
          <div class="col-span-9">
            <h2 class="text-lg font-bold my-6">Additional Applicants</h2>
          </div>
        </div>
      </div>

      <div>
        <h2 class="text-lg font-bold my-6">Add Applicant</h2>
        <p>Applicant will be sent a unique ID via email and text to access the rest of the application. Standard SMS
          rates apply.</p>
      </div>

      <form id="addApplicantForm" #addApplicantForm="ngForm" (ngSubmit)="onSubmit()" class="flex flex-col pt-8">
        <!-- Processing overlay -->
        <div *ngIf="isSubmitting" class="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div class="bg-white p-6 rounded-lg shadow-lg text-center">
            <mat-spinner diameter="40" class="mx-auto mb-4"></mat-spinner>
            <p class="text-lg font-semibold">Processing your request...</p>
            <p class="text-sm text-gray-600">Please wait while we add the applicant.</p>
          </div>
        </div>

        <div>
          <mat-form-field class="w-full my-2">
            <mat-label>First Name</mat-label>
            <input matInput name="FirstName" id="FirstName" required [(ngModel)]="model.FirstName" #FirstName="ngModel" autoFocus="true">
            <mat-error>Please enter a name</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="w-full my-2">
            <mat-label>Last Name</mat-label>
            <input matInput name="LastName" id="LastName" required [(ngModel)]="model.LastName" #LastName="ngModel">
            <mat-error>Please enter a name</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="w-full my-2">
            <mat-label>Email Address</mat-label>
            <input matInput name="Email" id="Email" required email [(ngModel)]="model.Email" #Email="ngModel">
            <mat-error>Please enter a valid email address</mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="w-full my-2">
            <mat-label>Home Phone</mat-label>
            <mat-input-tel name="HomePhone" id="HomePhone" required [(ngModel)]="homePhoneNumber" #HomePhone="ngModel">
            </mat-input-tel>
            <mat-error *ngIf="HomePhone?.touched && !isPhoneNumberComplete(homePhoneNumber)">
              Please enter a complete phone number (XXX-XXX-XXXX)
            </mat-error>
            <mat-error *ngIf="HomePhone.invalid && HomePhone.touched && isPhoneNumberComplete(homePhoneNumber)">
              Please enter a valid phone number
            </mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="w-full my-2">
            <mat-label>Cell Phone</mat-label>
            <mat-input-tel name="CellPhone" id="CellPhone" required [(ngModel)]="cellPhoneNumber" #CellPhone="ngModel">
            </mat-input-tel>
            <mat-error *ngIf="CellPhone.touched && !isPhoneNumberComplete(cellPhoneNumber)">
              Please enter a complete phone number (XXX-XXX-XXXX)
            </mat-error>
            <mat-error *ngIf="CellPhone.invalid && CellPhone.touched && isPhoneNumberComplete(cellPhoneNumber)">
              Please enter a valid phone number
            </mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-checkbox matInput name="IsNonLeaseHolderOccupant" id="IsNonLeaseHolderOccupant" [checked]="false"
            [(ngModel)]="model.IsNonLeaseHolderOccupant" binary="true">Leaseholder Access Applicant - No Credit/No Income - Only Criminal Background Check</mat-checkbox>
        </div>
        <div class="md:flex md:justify-end text-right">
          <div class="pt-4">
            <button mat-flat-button class="text-right" color="primary" (click)="onBackClick()" [disabled]="isSubmitting">CANCEL</button>
          </div>
          <div class="pt-4">
            <button mat-flat-button class="text-right md:mx-2" color="primary" (click)="onNewApplicantClick()"
              [disabled]="!isFormValid() || isSubmitting">
              <mat-spinner *ngIf="isSubmitting" diameter="20" class="inline mr-2"></mat-spinner>
              <span *ngIf="!isSubmitting">ADD ANOTHER APPLICANT</span>
              <span *ngIf="isSubmitting">PROCESSING...</span>
            </button>
          </div>
          <div class="pt-4">
            <button mat-flat-button class="text-right" color="primary" type="submit"
              [disabled]="!isFormValid() || isSubmitting">
              <mat-spinner *ngIf="isSubmitting" diameter="20" class="inline mr-2"></mat-spinner>
              <span *ngIf="!isSubmitting">ADD</span>
              <span *ngIf="isSubmitting">PROCESSING...</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
